module.exports = __webpack_public_path__ + "static/author-muso-mwango-9e8c3f28bc31fcf2be2a42cf365d6d60.png";